var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "app-loader-soft",
    cx: 60,
    cy: 60,
    r: 34,
    fill: "currentColor",
    fillOpacity: 0.07
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 42,
    stroke: "currentColor",
    strokeWidth: 8,
    strokeOpacity: 0.12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "app-loader-arc",
    cx: 60,
    cy: 60,
    r: 42,
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeDasharray: "66 198",
    transform: "rotate(-90 60 60)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLoader);
export default __webpack_public_path__ + "static/media/app-loader.bff10d801e9a34d1b1bd0b12005705f8.svg";
export { ForwardRef as ReactComponent };